<template>
  <div class="social-icons">
    <NuxtLink class="social-icon" v-for="social in socials" :href="social.href">
      <img class="social-icon__icon" :alt="social.name" :src="social.iconUri"/>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
const { getSocialMedia } = useWebsiteContent();
const { data: socials, suspense: suspenseSocials } = getSocialMedia();
await suspenseSocials();
</script>

<style scoped lang="scss">
.social-icons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  aspect-ratio: 1;
  height: 32px;

  //border: 2px solid white;

  &:hover {
    .social-icon__icon {
      width: 90%;
      height: 90%;
    }
  }

  &__icon {
    display: block;

    width: 100%;
    height: 100%;

    transition: all 100ms ease-out;

    border-radius: 8px;
  }
}
</style>